// src/App.js
import React from 'react';
import Terminal from './components/Terminal';


const App = () => {
    return (
        <div>
            <h1>Benvenuto nel Terminale</h1>
            <Terminal />
        </div>
    );
};

export default App;